// extracted by mini-css-extract-plugin
export var currencyInput = "_kr-1";
export var currencySymbol = "_kr-0";